import { EPatientStatus } from 'views/RoomView/RoomView.types'

export const shouldAllowPatientStatusRestrictedActions = (
  allowPatientStatusRestrictedActionsFlag: boolean,
  patientStatus?: EPatientStatus | string
): boolean => {
  return (
    allowPatientStatusRestrictedActionsFlag ||
    patientStatus === EPatientStatus.CHECKED_OUT ||
    patientStatus === EPatientStatus.ASSIGN_ROOM
  )
}
